import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Campaign } from 'src/app/core-module/models/Campaigns/campaign';
import { UtilService } from 'src/app/core-module/services/util.service';

@Component({
    selector: 'app-campaign-result',
    templateUrl: './campaign-result.component.html',
    styleUrl: './campaign-result.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CampaignResultComponent {

  @Input() campaign:Campaign

  public progress: number = 0;

  constructor(public util: UtilService) { 
  }

  humaniseDate(d: Date) {
    return this.util.shortHumanDate(d);
  }

  get strokeOffset() {
    const r = 40;
    const c = 2 * Math.PI * r;
    return c - (c * this.progress) / 100;
  }

  calcProgress(score:number,maxScore:number){
    if(maxScore>0){
      this.progress = Math.round((score/maxScore)*100)
      return this.progress;
    }
    this.progress = 0;
    return 0;
  }
}
